export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_7z8t6AsXQ',
      userPoolClientId: 'lgq8p1ktsfobv9ds1psrbhfl8',
      loginWith: {
        oauth: {
          domain: 'lpp-tekscapital.auth.eu-west-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: ['http://localhost:3000/'],
          redirectSignOut: ['http://localhost:3000/login'],
          responseType: 'code' as const
        }
      }
    }
  }
};